








import { getProjectVendors } from "@/api/gateways/vendor-api";
import SelectOption from "@/common/ui/presenters/select-option";
import Vendor from "@/models/vendor";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

/**
 * 工程の業者の選択
 */
@Component({})
export default class VendorSelect extends Vue {
  @Prop({ required: true }) project!: number; // 現場ID
  @Prop() work?: number; // 業種ID
  @Prop({ default: "" }) value!: string;

  vendor: string = "";
  vendors: Vendor[] = [];

  get options(): SelectOption[] {
    return this.filteredVendors.map(o => ({
      text: o.name,
      value: String(o.id)
    }));
  }

  private get filteredVendors(): Vendor[] {
    return vendorsOfWork(this.vendors, this.work);
  }

  @Watch("value", { immediate: true })
  onDefaultValueChanged(value: string) {
    this.vendor = value;
  }

  @Watch("project", { immediate: true })
  onProjectChanged(projectId: number) {
    this.initOptions(projectId);
  }

  private async initOptions(projectId: number): Promise<void> {
    this.vendors = await getProjectVendors({ projectId });
  }
}

/**
 * 業種で絞り込む
 */
function vendorsOfWork(vendors: Vendor[], taskTypeId?: number): Vendor[] {
  if (!taskTypeId) {
    return vendors;
  }
  return vendors.filter(v => v.workTypeIds.includes(taskTypeId));
}
